import { CommonModule } from '@angular/common';
import { Component, inject, type OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@application/auth/auth.service';
import { MenuService } from '@application/menu/menu.service';
import { FooterComponent } from '@presentation/shared/components/footer/footer.component';
import { LoadingPageComponent } from '@presentation/shared/components/loading-page/loading-page.component';
import { MenuComponent } from '@presentation/shared/components/menu/menu.component';
import { TopbarComponent } from '@presentation/shared/components/topbar/topbar.component';
import { DxButtonModule } from 'devextreme-angular';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [
    DxButtonModule,
    RouterOutlet,
    CommonModule,
    ButtonModule,
    MenuComponent,
    TopbarComponent,
    FooterComponent,
    Toast,
    LoadingPageComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'egtec-app-front';
  authService = inject(AuthService);
  menuService = inject(MenuService);
  logado = this.authService.usuario;
  display = this.menuService.getDisplay();
  minHeight = `min-height: calc(100vh - (90px + 47px))`;

  toggleMenu() {
    if (this.display()) {
      this.menuService.close();
    } else {
      this.menuService.open();
    }
  }

  ngOnInit() {}
}
